module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'function sum(array) {\n	return array.reduce( (x, y) => x+y, 0);\n}\n\nmodule.exports = sum;';

}
return __p
}